import * as React from "react";
import styled, { css } from "styled-components";
import { Badge } from "components/bootstrap";
import useHeaderBadge from "customization/header-badge/useHeaderBadge";
import InactiveNavItem from "components/navigation/InactiveNavItem";
const StyledBadge = styled(Badge)(
  ({ $color, theme }) => css`
    background-color: ${$color};
    color: ${theme.utils.readableColor($color)};
  `
);
const HeaderBadge = () => {
  const { data: badgeConfig } = useHeaderBadge();
  if (badgeConfig == null ? void 0 : badgeConfig.badge_enable) {
    return /* @__PURE__ */ React.createElement(InactiveNavItem, null, /* @__PURE__ */ React.createElement(StyledBadge, { $color: badgeConfig.badge_color, className: "dev-badge" }, badgeConfig.badge_text));
  }
  return null;
};
export default HeaderBadge;
